<script setup lang="ts">
import lottie from 'lottie-web/build/player/lottie_light';

import checkAnimation from '../../assets/animation/check.json';

export type GoneAlreadySignedContentProps = {
  isFullySigned?: boolean,
};

const props = defineProps<GoneAlreadySignedContentProps>();

const animationContainer = ref<HTMLElement>();

onMounted(() => {
  if (!animationContainer.value) throw new Error('Lottie animation container not found');

  lottie.loadAnimation({
    container: animationContainer.value,
    loop: false,
    animationData: checkAnimation,
    autoplay: true,
  });
});
</script>

<template>
  <div
    ref="animationContainer"
    :class="$style.animation"
    data-testid="alreadySignedAnimation"
  />

  <header :class="$style.header">
    <h3
      :class="$style.title"
      data-testid="alreadySignedContentTitle"
    >
      {{ $t('requirement.gone.alreadySigned.title') }}
    </h3>

    <I18nT
      data-testid="alreadySignedContentDescription"
      :keypath="
        props.isFullySigned ?
          'requirement.gone.alreadySigned.allAlreadySigned' :
          'requirement.gone.alreadySigned.afterAllSign'
      "
      tag="p"
    >
      <strong> {{ $t('requirement.gone.alreadySigned.downloadIt') }} </strong>
    </I18nT>
  </header>
</template>

<style lang="scss" module>
.header {
  max-width: 831px;
  margin-bottom: var(--space-small-xx);
  text-align: center;
}

.animation {
  width: 56px;
  height: 56px;
  margin-bottom: var(--space-small-xx);
}

</style>
